export const modal = (theme) => {
    return {
        sizes: {
            sm: '400px',
            md: '640px',
            lg: '768px',
            xl: '960px',
            full: 'calc(100vw - 32px)',
        },
        content: {
            backgroundColor: theme.colors?.surface?.default,
            color: theme.colors?.text?.basic?.primary,
            fontSize: theme.fontSizes?.md,
            fontWeight: theme.fontWeights?.[400],
            boxShadow: theme.shadows?.xl,
            borderRadius: theme.radii?.md,
        },
    };
};
//# sourceMappingURL=modal.js.map